import { MailIcon, PhoneIcon, UserIcon } from '@/shared/components/icons';

interface CustomerInfoProps {
    customer: {
        furigana: string,
        email: string,
        phone: string
    }
}

export default function CustomerInfo({ customer }: CustomerInfoProps) {
    return (
        <section className='flex gap-3 items-center'>
            <UserIcon className='md:size-20 size-16 text-text-secondary' />
            <div className='flex-1 md:space-y-1 space-y-0.5 text-sm'>
                <p>{customer.furigana}</p>
                <div className='flex items-center gap-2'>
                    <MailIcon size={16} />
                    <p className='text-text-secondary'>{customer.email}</p>
                </div>
                <div className='flex items-center gap-2'>
                    <PhoneIcon size={16} />
                    <p className='text-text-secondary'>{customer.phone}</p>
                </div>
            </div>
        </section>
    );
}
